<template>
  <div class="container-fluid">
    <ModalPopupInfo ref="modalPopupInfo"/>
    <div class="flex-center-space-between">
      <div class="mr-1" style="width:50%"><WidgetLivraisons /></div>
      <div class="ml-1" style="width:50%"><WidgetInformations /></div>
    </div>
    <div class="flex-center-space-between">
      <div class="mr-1" :style="'width:' + (afficheActualite ? '50%' : '100%')"><WidgetProductions /></div>
      <div class="ml-1" v-if="afficheActualite" style="width:50%"><WidgetActualites /></div>
    </div>
  </div>
</template>

<script>
import WidgetLivraisons from "@/components/Accueil/WidgetLivraisons"
import ModalPopupInfo from "@/components/Accueil/ModalPopupInfo"
import WidgetInformations from "@/components/Accueil/WidgetInformations"
import WidgetProductions from "@/components/Accueil/WidgetProductions"
import WidgetActualites from "@/components/Accueil/WidgetActualites"
import { mapActions } from "vuex"
import { connecteData } from "@/mixins/connecteData"
import { chargerDefinitions } from '@/helpers/definitions'
import { chargerDonneesEtablissement } from '../helpers/definitions'

export default {
  name: "home",
  mixins: [connecteData],
  components: { WidgetLivraisons, WidgetInformations, WidgetProductions, WidgetActualites, ModalPopupInfo },
  data() {
    return {
      afficheActualite: true,
      informations: []
    }
  },
  async created() {
    chargerDefinitions(this.etabCourantId)
    chargerDonneesEtablissement(this.etabCourantId)

    //await store.dispatch('definitions/chargerDefinitions', { key: "", etablissementId: this.etabCourantId })
    //await store.dispatch('definitions/chargerDefinitions', { key: "informationsAccueil", etablissementId: this.etabCourantId })
  },
  async mounted() {    
    
    this.afficheActualite = process.env.VUE_APP_AFFICHE_ACTUALITES === "true"
    this.$refs.modalPopupInfo.show()
    
    this.cacherAttente()
  },
  methods: {
    ...mapActions("uxHelpers", ["cacherAttente"])
  }
}
</script>
